<template>
  <div class="to-top" :class="{ isLogin: isLogin }" @click="scrollToTop"></div>
</template>

<script>
export default {
  name: 'ToTop',
  methods: {
    scrollToTop() {
      if (process.env.NODE_ENV === 'development') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        document.body.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.login.isLogin;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.to-top {
  overflow: hidden;
  z-index: 21;
  position: fixed;
  bottom: 440px;
  right: 10px;
  width: 70px;
  height: 70px;
  background: url($commonImg + 'm-totop.png') no-repeat center/contain;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;

  &.isLogin {
    bottom: 240px;
  }
}

#ssr-page.landscape {
  .to-top,
  .to-top.isLogin {
    right: 40px;
    bottom: 30px;
  }
}
</style>
